import { Stack } from '@optimus-web/core';
import { Reservation } from '@mews-commander/data-access';
import { ReservationOrderItems } from './ReservationOrderItems';
import { Balances } from './Balances';
import ReservationDetailCard from './ReservationDetailCard';
import { BasicReservationInfoCard } from './BasicReservationInfoCard';
import { UpsellContainer } from './UpsellContainer';

interface Props {
    reservation: Reservation;
}

const ReservationInfo = ({ reservation }: Props) => {
    const { id, groupId, reservationTimeState, serviceId, startUtc } = reservation;

    return (
        <Stack vertical spacing="200">
            <BasicReservationInfoCard reservation={reservation} />

            <UpsellContainer reservationId={id} startUtc={startUtc} reservationTimeState={reservationTimeState} />

            <Balances
                reservationId={id}
                serviceId={serviceId}
                groupId={groupId}
                reservationTimeState={reservationTimeState}
            />

            <ReservationOrderItems reservationId={id} serviceId={serviceId} />

            <ReservationDetailCard reservation={reservation} />
        </Stack>
    );
};

export default ReservationInfo;
